import React from "react";
import Axios from 'axios'
import { Button, Modal, Space, Table, Tooltip, Typography } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined, SyncOutlined } from "@ant-design/icons";
import AddEditSkillFrameworkModalForm from "./modals/AddEditSkillFrameworkModalForm";

import {Config} from './config_section.js'
const { confirm } = Modal
const { Title } = Typography;

const SkillsFramework = ({ refresh, showMessage, authData, usersData, rsSkillsGroup, rsSpecificKnowledge, rsSpecificSkills }) => {
  const [editRecord, setEditRecord] = React.useState(null);

  function showConfirmAction(id, isArchived) {
    confirm({
      title: isArchived ? "Are you sure you want to restore this skill group?" : "Are you sure you want to archive this skill group?",
      content: (
        <div>
          <p>
            <b>Name:</b> {rsSkillsGroup.find((obj) => obj.id === id).name}
          </p>
        </div>
      ),

      icon: <QuestionCircleOutlined style={{ color: "red" }} />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        try {
          return await new Promise((resolve, reject) => {
            Axios.post(Config.server.archiveSkillsGroup, { ...authData, id: id }, { headers: { "Content-Type": "application/json" } })
              .then((response) => {
                if (response && response.data.error === false) {
                  showMessage({ type: "success", content: `Record successfully ${isArchived ? "restored" : "archived"}.` });
                  refresh();
                  resolve();
                } else {
                  showMessage({ type: "error", content: "Something went wrong." });
                  reject();
                }
              })
              .catch((error) => {
                console.log(error);
                showMessage({ type: "error", content: "Something went wrong." });
                reject();
              });
          });
        } catch {
          showMessage({ type: "error", content: "Something went wrong." });
        }
      },
    });
  }

  const tableColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "48px",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Skill Group",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "ascend",
    },
    {
      title: "Specific Skills",
      dataIndex: "specific_skills",
      key: "specific_skills",
      render: (skills) => (
        <ul className="skills-group">
          {skills
            .map((skillId) => rsSpecificSkills.find((e) => e.id === skillId).name)
            .sort()
            .map((skillName, i) => (
              <li key={i}>{skillName}</li>
            ))}
        </ul>
      ),
    },
    {
      title: "Specific Knowledge",
      dataIndex: "specific_knowledge",
      key: "specific_knowledge",
      render: (knowledge) => (
        <ul className="skills-group">
          {knowledge
            .map((knowledgeId) => rsSpecificKnowledge.find((e) => e.id === knowledgeId).name)
            .sort()
            .map((knowledgeName, i) => (
              <li key={i}>{knowledgeName}</li>
            ))}
        </ul>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (color) => (
        <div
          className="color-box"
          style={{
            backgroundColor: color,
          }}
        >
          {color}
        </div>
      ),
    },
    {
      title: "Updated [CET]",
      dataIndex: "updated",
      key: "updated",
      width: "160px",
      sorter: (a, b) => a.updated.localeCompare(b.updated),
    },
    {
      title: "Created [CET]",
      dataIndex: "created",
      key: "created",
      width: "160px",
      sorter: (a, b) => a.created.localeCompare(b.created),
    },
    {
      title: "Archived [CET]",
      dataIndex: "archived",
      key: "archived",
      width: "160px",
      sorter: (a, b) => a.archived.localeCompare(b.archived),
    },
    {
      title: "Action",
      key: "action",
      width: "60px",
      render: (record) => (
        <Space size="small">
          <Tooltip title="Edit row">
            <EditOutlined className="editIcon" onClick={() => setEditRecord(rsSkillsGroup.find((obj) => obj.id === record.id))} />
          </Tooltip>
          <Tooltip title={record.archived ? "Restore row" : "Archive row"}>
            {record.archived ? (
              <SyncOutlined className="restoreIcon" onClick={() => showConfirmAction(record.id, true)} />
            ) : (
              <DeleteOutlined className="deleteIcon" onClick={() => showConfirmAction(record.id, false)} />
            )}
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div id="skills-framework">
      <Title className="pageTitle">REWIRE Skills Framework</Title>

      <div className="dataHandleButtons">
        <Space>
          <Button onClick={() => setEditRecord("new")}>
            <PlusOutlined className="icon-position-fix" /> Add Skill Group
          </Button>
        </Space>
      </div>
      <Table size="small" className="data-table skill-group-table" dataSource={rsSkillsGroup} pagination={false} columns={tableColumns} rowClassName={(skillGroup) => (skillGroup.archived ? "archived-row" : "")}/>

      {/* modals */}
      <AddEditSkillFrameworkModalForm
        editRecord={editRecord}
        refresh={refresh}
        showMessage={showMessage}
        onCancel={() => setEditRecord(null)}
        authData={authData}
        rsSkillsGroup={rsSkillsGroup}
        usersData={usersData}
        rsSpecificSkills={rsSpecificSkills}
        rsSpecificKnowledge={rsSpecificKnowledge}
      />
    </div>
  );
};

export default SkillsFramework;
